import type { Embed, Thumbnail } from "@/shared/api/book";

/** Hogyan tölti ki az ajánlás képe a kártya 16:9-es fedlapját: a fekvő kép kitölti; az álló
 *  vagy négyzetes (könyvborító, filmplakát) teljes egészében középre kerül, mögötte ugyanaz
 *  elmosva; a YouTube-csatorna avatárja kerek, alatta a csatorna neve (A1 változat,
 *  2026-09-21); kép nélkül krém fedlap a típus ikonjával. A kártya és az admin felirata is
 *  ebből dolgozik. */
export type CoverKind = "fill" | "contain" | "channel" | "empty";

export function coverKind(item: { thumbnail: Thumbnail | null; embed: Embed | null }): CoverKind {
  if (!item.thumbnail) return "empty";
  if (item.embed?.kind === "channel") return "channel";
  return item.thumbnail.width / item.thumbnail.height >= 1.3 ? "fill" : "contain";
}
